"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrganizationRoleAccessListIdentifier = getOrganizationRoleAccessListIdentifier;
exports.getEnterpriseRoleAccessListIdentifier = getEnterpriseRoleAccessListIdentifier;
exports.getUserAccessListIdentifier = getUserAccessListIdentifier;
exports.generateUserAccessListForDocument = generateUserAccessListForDocument;
exports.generateUserAccessListForQuery = generateUserAccessListForQuery;
const constants_1 = require("@buildwithflux/constants");
const permissionType_1 = require("./permissionType");
/**
 * Gets an organization role access identifier for a specific organization and role
 */
function getOrganizationRoleAccessListIdentifier(organizationUid, organizationRole) {
    return `${organizationUid}_${organizationRole}`;
}
/**
 * Gets an organization role access identifier for a specific organization and role
 */
function getEnterpriseRoleAccessListIdentifier(enterpriseUid, enterpriseRole) {
    return `${enterpriseUid}_${enterpriseRole}`;
}
/**
 * Gets a user access identifier for a specific user
 */
function getUserAccessListIdentifier(userUid) {
    return `usr_${userUid}`;
}
/**
 * Given a document, with roles, generate a list of users who have at least view access.
 */
function generateUserAccessListForDocument(document, roles) {
    const userAccessList = roles
        .filter((role) => role.permission_type !== permissionType_1.PermissionType.none)
        .flatMap((role) => [role.user_uid, getUserAccessListIdentifier(role.user_uid)]);
    if (document.owner_uid) {
        userAccessList.push(document.owner_uid, getUserAccessListIdentifier(document.owner_uid));
    }
    if (document.organization_owner_uid) {
        // Organization owner is in the access list
        userAccessList.push(getOrganizationRoleAccessListIdentifier(document.organization_owner_uid, "owner"));
        if (document.organization_member_permission_type !== permissionType_1.PermissionType.none) {
            // Organization members are in the access list
            userAccessList.push(getOrganizationRoleAccessListIdentifier(document.organization_owner_uid, "member"));
        }
    }
    if (document.enterprise_owner_uid) {
        // Enterprise owner is in the access list
        userAccessList.push(getEnterpriseRoleAccessListIdentifier(document.enterprise_owner_uid, "owner"));
        if (document.enterprise_member_permission_type !== permissionType_1.PermissionType.none) {
            // Enterprise members are in the access list
            userAccessList.push(getEnterpriseRoleAccessListIdentifier(document.enterprise_owner_uid, "member"));
        }
    }
    return userAccessList;
}
/**
 * Generates a user access list for the querying side
 *
 * This is the list of identifiers that the current user (if there is one) has visibility into. If one or more of these
 * identifiers appears in the corresponding user_access_list of a document (produced by generateUserAccessListForDocument),
 * then the user has at least read access to that document.
 *
 * Note that for Firestore queries in particular, you should use generateUserAccessListForFirestoreQuery instead.
 */
function generateUserAccessListForQuery(userUid, organizationMemberships) {
    // The anonymous user only has access as the anonymous role
    if (!userUid) {
        return [constants_1.ANON_ROLE_UID];
    }
    // Otherwise access may come via a specific user role, or document ownership, both of which are denoted with a userUid
    const forQuery = [constants_1.ANON_ROLE_UID, userUid];
    // Or, access may come via the organizations of which the user is a member
    for (const membership of organizationMemberships) {
        forQuery.push(getOrganizationRoleAccessListIdentifier(membership.organizationUid, membership.role));
    }
    return forQuery;
}
//# sourceMappingURL=accessList.js.map